import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHeroError = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 384,
	height: 346,
	viewBox: "0 0 384 346",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		opacity: .8,
		children: [/* @__PURE__ */ _jsx("g", {
			opacity: .5,
			filter: "url(#filter0_f_3514_787)",
			children: /* @__PURE__ */ _jsx("ellipse", {
				cx: 191,
				cy: 173,
				rx: 133,
				ry: 113,
				fill: "url(#paint0_linear_3514_787)"
			})
		}), /* @__PURE__ */ _jsxs("g", {
			opacity: .7,
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M108.984 259.69H160.509C163.34 259.69 165.697 257.516 165.924 254.693L172.911 167.835H96.5812L103.568 254.693C103.796 257.515 106.152 259.69 108.983 259.69H108.984Z",
					fill: "#BAE6E5"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M174.245 167.835H95.2499C92.8614 167.835 90.9223 165.896 90.9223 163.507C90.9223 161.119 92.8614 159.18 95.2499 159.18H174.245C176.633 159.18 178.572 161.119 178.572 163.507C178.572 165.896 176.633 167.835 174.245 167.835Z",
					fill: "#4BBEBA"
				}),
				/* @__PURE__ */ _jsx("g", {
					style: { mixBlendMode: "multiply" },
					opacity: .4,
					children: /* @__PURE__ */ _jsx("path", {
						d: "M96.8004 170.552L96.5812 167.835H172.911L172.693 170.552H96.8004Z",
						fill: "#84D2D1"
					})
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M97.3515 167.835C98.2991 184.665 114.564 198.109 134.423 198.109C154.282 198.109 170.548 184.665 171.494 167.835H174.242C173.302 186.18 155.802 200.854 134.423 200.854C113.044 200.854 95.51 186.151 94.6022 167.782C94.8135 167.814 95.0287 167.836 95.2499 167.836H97.3525L97.3515 167.835Z",
					fill: "#07A5A2",
					fillOpacity: .37
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M134.422 189.923C140.321 189.923 145.547 191.062 148.778 192.812V201.101C145.546 202.853 140.321 203.991 134.422 203.991C128.523 203.991 123.297 202.852 120.066 201.101V192.812C123.298 191.061 128.523 189.923 134.422 189.923Z",
					fill: "#07A5A2"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M127.878 159.179V193.885C127.878 195.051 126.933 195.996 125.767 195.996H125.156C123.99 195.996 123.044 195.051 123.044 193.885V182.317C123.044 182.004 122.833 181.717 122.525 181.658C122.112 181.579 121.75 181.893 121.75 182.293V193.885C121.75 195.051 120.804 195.996 119.638 195.996C118.473 195.996 117.527 195.051 117.527 193.885V182.329C117.527 181.978 117.265 181.664 116.915 181.646C116.542 181.626 116.233 181.923 116.233 182.292V193.884C116.233 195.05 115.288 195.995 114.122 195.995C112.956 195.995 112.01 195.05 112.01 193.884V182.316C112.01 182.003 111.799 181.716 111.491 181.657C111.078 181.578 110.716 181.892 110.716 182.292V193.884C110.716 195.05 109.77 195.995 108.605 195.995H107.994C106.828 195.995 105.882 195.05 105.882 193.884V159.178H127.876L127.878 159.179Z",
					fill: "#07A5A2"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M136.037 159.179H158.573L151.894 189.062C151.64 190.2 150.511 190.916 149.373 190.662L148.777 190.528C147.639 190.274 146.923 189.145 147.177 188.007L149.7 176.717C149.768 176.412 149.624 176.086 149.337 175.961C148.95 175.794 148.529 176.022 148.442 176.411L145.913 187.724C145.659 188.862 144.53 189.579 143.392 189.325C142.254 189.071 141.538 187.942 141.792 186.804L144.313 175.527C144.39 175.185 144.202 174.821 143.864 174.727C143.505 174.627 143.139 174.849 143.058 175.209L140.529 186.522C140.275 187.66 139.146 188.376 138.008 188.122C136.87 187.868 136.154 186.739 136.408 185.601L138.931 174.311C138.999 174.006 138.855 173.679 138.568 173.555C138.182 173.387 137.76 173.615 137.673 174.005L135.144 185.318C134.89 186.456 133.761 187.172 132.623 186.918L132.027 186.785C130.889 186.531 130.173 185.402 130.427 184.264L136.034 159.179H136.037Z",
					fill: "#07A5A2"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M199.541 243.739L201.99 242.875L203.4 258.859L200.95 259.722L199.541 243.739Z",
					fill: "#07A5A2",
					fillOpacity: .6
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M207.248 230.104L209.697 229.24C204.699 231.003 201.423 236.441 201.99 242.876L199.541 243.74C198.974 237.306 202.249 231.867 207.248 230.104Z",
					fill: "#07A5A2",
					fillOpacity: .6
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M181.455 100.145C180.75 100.145 180.079 100.263 179.456 100.483L177.007 101.347C177.63 101.128 178.3 101.009 179.006 101.009H260.942L263.391 100.145H181.455Z",
					fill: "#FFE133"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M268.68 109.007L271.129 108.143L284.505 258.859L282.055 259.723L268.68 109.007Z",
					fill: "#07A5A2",
					fillOpacity: .6
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M260.942 101.009C264.825 101.009 268.29 104.59 268.68 109.005L282.055 259.722H267.157L265.748 243.738C265.055 235.876 258.888 229.502 251.973 229.502H210.805C203.892 229.502 198.847 235.876 199.541 243.738L200.95 259.722H186.053L172.678 109.006C172.289 104.59 175.122 101.01 179.006 101.01H260.942V101.009ZM243.509 121.429C246.23 121.429 248.215 118.92 247.942 115.825C247.669 112.731 245.242 110.221 242.521 110.221H198.232C195.509 110.221 193.524 112.731 193.797 115.825C194.07 118.92 196.498 121.429 199.219 121.429H243.509Z",
					fill: "#07A5A2"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M260.942 101.009L263.391 100.145C267.275 100.145 270.739 103.726 271.129 108.142L268.68 109.006C268.29 104.589 264.825 101.009 260.942 101.009Z",
					fill: "#07A5A2",
					fillOpacity: .6
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M197.784 121.192L195.335 120.328C193.368 119.634 192.078 117.494 192.302 114.961C192.575 111.867 195.002 109.357 197.723 109.357L200.173 110.221C197.45 110.221 195.023 112.731 194.751 115.825C194.528 118.358 195.816 120.498 197.784 121.192Z",
					fill: "#07A5A2",
					fillOpacity: .37
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M174.497 242.875L176.946 243.739L175.537 259.724L173.088 258.86L174.497 242.875Z",
					fill: "#07A5A2",
					fillOpacity: .37
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M173.088 258.86L175.537 259.724H160.64L158.191 258.86H173.088Z",
					fill: "#CEEDEC"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M188.272 228.64L190.721 229.504C183.807 229.504 177.639 235.876 176.946 243.74L174.497 242.876C175.19 235.012 181.357 228.64 188.272 228.64Z",
					fill: "#07A5A2",
					fillOpacity: .37
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M242.42 109.593C241.983 109.44 241.514 109.357 241.02 109.357H197.724L200.174 110.221H243.469C243.963 110.221 244.433 110.304 244.869 110.457L242.42 109.593Z",
					fill: "#CEEDEC"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M263.239 99.4887L265.688 100.353C268.495 101.343 270.336 104.397 270.017 108.011L267.568 107.148C267.887 103.532 266.046 100.478 263.239 99.4887Z",
					fill: "#07A5A2",
					fillOpacity: .37
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M232.998 229.241C231.889 228.849 230.695 228.64 229.44 228.64H188.272L190.721 229.504H231.889C233.145 229.504 234.339 229.714 235.448 230.105L232.998 229.241Z",
					fill: "#CEEDEC"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M267.568 107.147L270.017 108.011L256.641 259.724L254.192 258.86L267.568 107.147Z",
					fill: "#07A5A2",
					fillOpacity: .37
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M261.24 99.1505C265.123 99.1505 267.957 102.73 267.568 107.147L254.192 258.86H239.295L240.704 242.876C241.397 235.013 236.353 228.64 229.44 228.64H188.272C181.357 228.64 175.189 235.013 174.497 242.876L173.088 258.86H158.191L171.566 107.147C171.956 102.73 175.421 99.1505 179.304 99.1505H261.24ZM240.031 120.565C242.753 120.565 245.181 118.055 245.453 114.96C245.726 111.866 243.74 109.356 241.019 109.356H197.723C195.001 109.356 192.574 111.866 192.302 114.96C192.029 118.055 194.014 120.565 196.736 120.565H240.031Z",
					fill: "#CEEDEC"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M254.192 258.86L256.641 259.724H241.744L239.295 258.86H254.192Z",
					fill: "#CEEDEC"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M189.348 198.011C187.495 198.011 185.965 196.901 185.258 195.041C184.55 193.181 184.837 191.026 186.024 189.276L212.546 150.2C213.616 148.623 215.188 147.718 216.859 147.718C218.529 147.718 219.942 148.623 220.734 150.2L240.366 189.276C241.245 191.026 241.151 193.181 240.116 195.041C239.08 196.9 237.356 198.011 235.502 198.011H189.348ZM217.066 145.373C214.731 145.373 212.445 146.688 210.949 148.892L184.428 187.969C182.744 190.449 182.337 193.506 183.341 196.144C184.345 198.78 186.513 200.356 189.142 200.356H235.296C237.924 200.356 240.37 198.78 241.839 196.144C243.308 193.506 243.44 190.45 242.195 187.969L222.562 148.892C221.455 146.688 219.4 145.373 217.067 145.373",
					fill: "#07A5A2"
				})
			]
		})]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
		id: "filter0_f_3514_787",
		x: -2,
		y: 0,
		width: 386,
		height: 346,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "BackgroundImageFix",
				result: "shape"
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", {
				stdDeviation: 30,
				result: "effect1_foregroundBlur_3514_787"
			})
		]
	}), /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_3514_787",
		x1: 58,
		y1: 173,
		x2: 324,
		y2: 173,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#0CA5A2" }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#5CD7A3"
		})]
	})] })]
});
export default SvgHeroError;
